import { render } from "./VODClipsTab.vue?vue&type=template&id=15f3cd79"
import script from "./VODClipsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VODClipsTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/VODClipsTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15f3cd79"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15f3cd79', __exports__)) {
    api.reload('15f3cd79', __exports__)
  }
  
  module.hot.accept("./VODClipsTab.vue?vue&type=template&id=15f3cd79", () => {
    api.rerender('15f3cd79', render)
  })

}


export default __exports__